export function GoogleAnalyticsService($window) {
    'ngInject';
    let managementGroupName = '';

    // Small kludge to avoid mock boilerplate in tests.
    const ga = $window.ga || function() {};

    const svc = {
        setName,
        trackAddressSearchEvent,
        trackButtonClickEvent,
        trackLinkClickEvent,
        trackPageViewEvent
    };

    activate();
    return svc;

    function activate() {
        ga('set', 'appName', process.env.PKG_NAME); // eslint-disable-line no-undef, no-process-env
        ga('set', 'appVersion', process.env.PKG_VERSION); // eslint-disable-line no-undef, no-process-env
    }

    function setName(name) {
        managementGroupName = name;
        // TODO We should be able to just set dimension1 here as well instead of manually
        // in each trackX() method.
    }

    function trackAddressSearchEvent(label) {
        ga('send', 'event', 'address', 'search', label, {
            dimension1: managementGroupName,
            dimension2: '3'
        });
    }

    function trackButtonClickEvent(label) {
        ga('send', 'event', 'button', 'click', label, {
            dimension1: managementGroupName,
            dimension2: '3'
        });
    }

    function trackLinkClickEvent(label) {
        ga('send', 'event', 'link', 'click', label, {
            dimension1: managementGroupName,
            dimension2: '3'
        });
    }

    function trackPageViewEvent(page) {
        ga('send', 'pageview', page, {
            dimension1: managementGroupName,
            dimension2: '3'
        });
    }
}
